import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import { getDefaultImageByType } from 'shared/constants/defaultImages';

import Title from './../Title/Title';
// eslint-disable-next-line css-modules/no-unused-class
import s from './../LeasingOnlineBanner.css';

class UserDataFormWithPhotoDialogWrapper extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    advertInfo: PropTypes.shape().isRequired,
    header: PropTypes.string,
    titleHTML: PropTypes.string,
    showTitle: PropTypes.bool,
    showAgreemant: PropTypes.bool,
    monthlyPayment: PropTypes.number,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    showTitle: true,
    showAgreemant: true,
    monthlyPayment: 0,
    header: '',
    titleHTML: '',
  };

  render() {
    const { t, children, advertInfo, showTitle, showAgreemant } = this.props;
    const { photos, transport } = advertInfo;

    const advertImage =
      (photos && photos[0] && photos[0].image) || getDefaultImageByType(transport);
    const locale = t('locale') === 'ru' ? '' : `${t('locale')}_`;
    const agreementLink = `/pdf/${locale}terms-of-use.pdf`;

    let { header } = this.props;
    const { titleHTML } = this.props;

    if (!header) header = t('avtobazar.ua лизинг');

    return (
      <div>
        {showTitle && <Title title={header} />}
        <div className={s.LeasingContainerContent}>
          <div className={s.headBlock}>
            <img src={advertImage} alt="" />
            <span dangerouslySetInnerHTML={{ __html: titleHTML }}>
              {/* <b>{priceTitle}</b> <br /> {t('за этот автомобиль')} */}
            </span>
          </div>
          {children}
          {showAgreemant && (
            <div className={s.agreeInfo}>
              {t('USER_AGREEMENT_DLG_TITLE_1')}
              <br />
              <a
                className={s.modalTextLink}
                href={agreementLink}
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                {t('USER_AGREEMENT_DLG_TITLE_2')}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(UserDataFormWithPhotoDialogWrapper));



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/UserDataForm/UserDataFormWithPhotoDialogWrapper.js